<template>
  <div>
    <Modal v-model="isShow" @on-ok="ok" :loading="loading" :mask-closable="false" :class-name="z100000">
      <h3 slot="header" class="modal-header">图片上传</h3>
      <div style="display: flex;flex-wrap: wrap" v-if="data">
          <img class="imgwidth" v-if="data[0].attachmentImgUrl"  :src="data[0].attachmentImgUrl"/>
          <Upload class="upload"
                  :action="baseUrl+'/file/uploadFile'"
                  :on-success="handleSuccess"
                  :headers="{'Access-Token':token}"
                  :show-upload-list="false"
                  :on-error="handleError"
                  :format="['jpg','jpeg','png']"
                  :on-format-error="formatError"

          >
            <Icon type="ios-plus-empty" size="80" style="vertical-align: middle"></Icon>
          </Upload>

      </div>
    </Modal>
  </div>
</template>

<script>
  import {getBaseUrl} from "../../../../utils/public";
  import {getToken} from "../../../../utils/auth";
  import {
    labelgetConfigImg,
    labeladdConfigImg,
    labeleditConfigImg,
    labelremoveConfigImg
  } from "../../../../api/projectConfig";

  export default {
    name: "ImgUpload",
    props: {
      n: {
        type: Number,
        default: 0
      },
      fid: {
        type: String,
        default: ''
      }
    },
    watch: {
      n() {
        this.data=[]
        this.labelgetConfigImg()
        this.isShow = true
        this.isShow=true
      },
    },
    data() {
      return {
        isShow: false,
        data: [],
        loading: true,
        token: '',
        baseUrl: '',
        z100000: 'z100000',
      }
    },
    methods: {
      formatError(){
        this.$Message.info('请上传图片类型文件')
      },
      labelgetConfigImg() {
        if (!this.fid) {
          return
        }
        let params = {
          fid: this.fid
        }
        labelgetConfigImg(params).then(res => {
          this.data = res.data
        }).catch(error=>{})
      },
      handleError() {

      },
      handleSuccess(res) {
        let params = {
          fid: res.data.fid,
          attachmentImgUrl: res.data.url,
          moduleFid: this.fid
        }
        labeladdConfigImg(params).then(res1 => {
          this.data.push(res1.data)
        }).catch(error=>{})
      },
      deleteItem(item) {

        let params = {
          fid: item.fid
        }
        labelremoveConfigImg(params).then(res => {
          this.labelgetConfigImg()
        }).catch(error=>{})

      },
      ok() {
        this.data.forEach((ele, index) => {
          ele['attachmentOrder'] = index
        })
        labeleditConfigImg(this.data).then(res => {
          this.isShow = false
          this.$Message.success('图片配置成功')
        }).catch(error=>{})
      },
    },
    created() {
      this.baseUrl = getBaseUrl()
      this.token = getToken()
    }

  }
</script>

<style scoped>
  .upload {
    display: inline-block;
    width: 150px;
    height: 85px;
    border: 1px dashed rgb(220, 220, 220);
    box-sizing: border-box;
    text-align: center;
    line-height: 80px;
  }

  .fileItem {
    margin-right: 20px;
  }

  .content-right {
    /*border: 1px solid black;*/
    overflow: hidden;
    display: flex;
    padding-left: 20px;
    box-sizing: border-box;

  }

  .file-img {
    width: 150px;
    height: 85px;
    overflow: hidden;
    display: inline-block;
    /*margin-bottom: 20px;*/
  }

  .input-width {
    width: 150px;
    margin-bottom: 10px;
  }


</style>
